import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { SharedModule }            from '../shared/shared.module';
import { WsApiSecretKeyComponent } from './ws-api.secret-key.component';
import { WsApiService }            from './ws-api.service';
import { WsApiSettingsComponent }  from './ws-api.settings.component';
import { WsApiStates }             from './ws-api.states';

@NgModule({
  declarations: [
    WsApiSecretKeyComponent,
    WsApiSettingsComponent
  ],
  entryComponents: [
    WsApiSecretKeyComponent,
    WsApiSettingsComponent
  ],
  imports: [
    SharedModule,

    UIRouterModule.forChild({ states: WsApiStates })
  ],
  providers: [
    WsApiService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class WsApiModule {}
